/* globals window */
const GLOBALS = typeof window === 'undefined' ? global : window

export const getPathWithDomain = path => GLOBALS.GIGPLANET_SETTINGS.SERVER_HOST + path

export const getBreadcrumbJsonLd = items => {
  if (!items || items.length === 0) {
    return null
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: getPathWithDomain(item.path),
    })),
  }
}

export const getCollectionPageJsonLd = ({ name, description, path, artists }) => {
  if (!artists || artists.length === 0) {
    return null
  }
  const itemListElement = artists
    .filter(artist => artist && artist.slug)
    .map((artist, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: artist.name,
      url: getPathWithDomain(`/${artist.artistType || 'artist'}/${artist.slug}`),
    }))
  if (itemListElement.length === 0) {
    return null
  }
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name,
    url: getPathWithDomain(path),
    inLanguage: 'nb-NO',
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: itemListElement.length,
      itemListElement,
    },
  }
  if (description) {
    jsonLd.description = description
  }
  return jsonLd
}
